<template>
  <div class="wrap">
    <Nav :title="$t('user.basicInformation')" fixed safeAreaInsetTop placeholder />
    <div class="content">
      <div class="info_item">
        <div class="item">
          <div class="label">{{ $t('fullName') }}</div>
          <div class="value">{{ form.name }}</div>
        </div>
        <div class="item">
          <div class="label">{{ $t('idNumber') }}</div>
          <div class="value">{{ form.idcard }}</div>
        </div>
        <div class="item">
          <div class="label">{{ $t('gender') }}</div>
          <div class="value">{{ getGender(form.gender) }}</div>
        </div>
        <div class="item">
          <div class="label">{{ $t('birthday') }}</div>
          <div class="value">{{ form.birthday }}</div>
        </div>
      </div>
      <div class="info_item">
        <div class="item">
          <div class="label">{{ $t('bank') }}</div>
          <div class="value">{{ form.bank }}</div>
        </div>
        <div class="item">
          <div class="label">{{ $t('bankNumber') }}</div>
          <div class="value">{{ form.card }}</div>
        </div>
      </div>
      <div class="info_item">
        <div class="item">
          <div class="label">{{ $t('maritalStatus') }}</div>
          <div class="value">{{ getMaritalStatus(form.maritalStatus) }}</div>
        </div>
        <div class="item">
          <div class="label">{{ $t('education') }}</div>
          <div class="value">{{ getEducation(form.education) }}</div>
        </div>
        <div class="item">
          <div class="label">{{ $t('careerInformation') }}</div>
          <div class="value">{{ form.job }}</div>
        </div>
        <div class="item">
          <div class="label">{{ $t('province') }}</div>
          <div class="value">{{ form.province }},{{ form.city }}</div>
        </div>
        <div class="item">
          <div class="label">{{ $t('address') }}</div>
          <div class="value">{{ form.address }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Icon } from "vant";
import Nav from "@/components/Navbar";
import { USER_LEVELAUTH } from "@/api";
export default {
  components: {
    [Icon.name]: Icon,
    Nav
  },
  data() {
    return {
      form: {}
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getGender(index) {
      if (index == 0) return this.$t('female');
      return this.$t('male')
    },
    getMaritalStatus(index) {
      switch (index) {
        case 0:
          return this.$t('single')
          break;
        case 1:
          return this.$t('married')
          break;
        case 2:
          return this.$t('divorced')
          break;
        case 3:
          return this.$t('widowed')
          break;
        default:
          break;
      }
    },
    getEducation(index) {
      switch (index) {
        case 0:
          return this.$t('juniorHigh')
          break;
        case 1:
          return this.$t('middleSchool')
          break;
        case 2:
          return this.$t('highSchool')
          break;
        case 3:
          return this.$t('graduateAbove')
          break;
        case 4:
          return this.$t('none')
          break;
        default:
          break;
      }
    },
    async getData() {
      try {
        const res = await USER_LEVELAUTH({});
        this.form = { ...res.data.auth_data || {} }
      } catch (error) { }
    },
  }
}
</script>
<style lang="less" scoped>
.wrap {
  min-height: 100vh;
  background-color: #f5f7fc;

  .content {
    padding: calc(30rem / 16) calc(10rem / 16);

    .info_item {
      background-color: #e8e8e8;
      margin-bottom: calc(30rem / 16);
      border-top: 1px dashed var(--black);

      .item {
        padding: calc(5rem / 16) calc(10rem / 16);
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        font-size: calc(14rem / 16);
        border-bottom: 1px dashed var(--black);

        .label {
          color: var(--black);
          line-height: calc(30rem /16);
        }

        .value {
          width: calc(150rem / 16);
          color: var(--black);
          line-height: calc(30rem /16);
          padding: 0 0 0 calc(15rem / 16);
          text-align: right;
          display: flex;
          align-items: center;
          justify-content: end;
        }
      }
    }

    .info_item:last-child {
      margin-bottom: 0;
    }
  }
}
</style>